import React from 'react';
import { Button, Grid, TextField } from '@mui/material';
import { Formik } from 'formik';
import PasswordField from '../PasswordField';
import validationSignIn from './validation';

interface SignInProps {
  handleSubmitChange: (
    params: SignInTypes,
    setSubmitting: (isSubmitting: boolean) => void,
  ) => void;
}

interface SignInTypes {
  email: string;
  password: string;
}

const SignInform: React.FC<SignInProps> = ({ handleSubmitChange }) => {
  return (
    <>
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validateOnBlur
        onSubmit={(values: SignInTypes, { setSubmitting }) => {
          handleSubmitChange(values, setSubmitting);
        }}
        validationSchema={validationSignIn}
      >
        {({ handleSubmit, values, errors, handleChange, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Grid px="25%" container justifyContent="center" gap="40px">
              <TextField
                autoComplete="off"
                value={values.email}
                onChange={handleChange}
                name="email"
                label="email"
                error={!!errors.email}
                helperText={errors.email}
                fullWidth
              />

              <PasswordField
                label="password"
                name="password"
                value={values.password}
                handleChange={handleChange}
                error={errors.password}
              />
              <Button
                variant="contained"
                disabled={isSubmitting}
                type="submit"
                color="primary"
                fullWidth
              >
                Login
              </Button>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default SignInform;
